// Third-party libraries
import React from "react";
import { Typography } from "@mui/material";

// Local modules
import { storage } from "../../../utils";
import HorizontalScrollList from "../components/HorizontalScrollList";

function RecentlyView() {
  const RecentlyViewed = JSON.parse(
    storage.getSessionStorageItem("hsRecentlyViewedProducts")
  );
  const cRecentlyViewed = RecentlyViewed ? [...RecentlyViewed] : [];
  cRecentlyViewed.reverse();
  return (
    <>
      <Typography variant="h2" sx={{ marginTop: "2rem" }}>
        Recently Viewed
      </Typography>
      {cRecentlyViewed.length > 0 && (
        <HorizontalScrollList loadedStyles={cRecentlyViewed} />
      )}
    </>
  );
}

export default RecentlyView;
